var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Navbar'),_c('Sidecart'),_c('Toast'),_c('router-view'),_c('div',{staticClass:"home_footer"},[_c('Footer')],1),_c('Gotop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }